<ng-template #customLoadingTemplate>
   
</ng-template>
<ngx-loading [show]="loading"  [config]="{ fullScreenBackdrop: true, backdropBackgroundColour: 'rgba(250, 251, 255, 0.8)', primaryColour : '#0B4974', animationType: ngxLoadingAnimationTypes.rectangleBounce}" [template]="customLoadingTemplate"></ngx-loading>